<template>
  <div class="applyManage">
    <template v-if="isApplyManage">
      <el-alert title="" type="warning">
        <div class="importantNote">
          <i class="iconfont icon-kaiqi f16 col_FEAF0D mr5"></i>
          <span>当前批次报名截止时间为<span>{{ endTime }}</span>,请尽快完成相关操作</span>
        </div>
      </el-alert>

      <el-alert title="" type="warning" v-if="!apptitle">
        <span class="importantNote" v-for="item in appointment" :key="item.index">
          <span>{{ item.examDate }}</span>
          <span>预约考试人数</span>
          <span style="margin-right: 20px">{{ item.stuCount }}人</span>
        </span>
      </el-alert>

      <ots-main-title :mainTopBtn="getMainTopBtnList"></ots-main-title>

      <ots-custom-dialog :dialog.sync="baseImportDialog" title="基本信息导入">
        <template v-slot:content>
          <div class="exportDialog">
            <el-form ref="exportForm" :model="importForm">
              <el-form-item label="选择批次" class="mb20">
                <el-select v-model="importForm.planId" clearable placeholder="请选择">
                  <el-option v-for="item in examBatchList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="1.模板下载">
                <span style="color: #006aff" @click="excelTempCreateExt()" class="cp">
                  <i class="el-icon-download"></i>
                  下载基本信息导入数据模板
                </span>
              </el-form-item>
              <el-form-item label="2.导入条件选择">
                <el-checkbox v-model="importForm.preRegistrationState" :true-label="1" :false-label="0" :disabled="stateDisabled">需要学生二次填报</el-checkbox>
                <div v-if="stateDisabled" class="illustration">
                  当前批次设置“允许学生选择考试日期”无法取消勾选，若想取消请在本批次中去掉“允许学生选择考试日期”勾选
                </div>
              </el-form-item>
              <el-form-item>
                <el-checkbox v-model="importForm.limitRegionState" :true-label="1" :false-label="0">只能名单范围内的学生报名</el-checkbox>
              </el-form-item>
              
              <el-form-item>
                <p slot="label" class="markField">设置已导入信息学生平台哪些字段不允许修改 <span>（默认不允许学生自行修改，如需要学生修改请取消勾选）</span></p>
                <el-checkbox v-model="forbidden" :true-label="1" :false-label="0">
                  {{isShowLevel ? '层次、': ''}}{{isShowSubject ? '专业、': ''}}课程
                </el-checkbox>
                <!-- <el-checkbox v-model="importForm.gradationForbidden" :true-label="1" :false-label="0" v-if="isShowLevel">
                  层次
                </el-checkbox>
                <el-checkbox v-model="importForm.subjectForbidden" :true-label="1" :false-label="0" v-if="isShowSubject">
                  专业
                </el-checkbox>
                <el-checkbox v-model="importForm.courseForbidden" :true-label="1" :false-label="0">
                  课程
                </el-checkbox> -->
                <!-- <div v-if="stateDisabled" class="illustration">
                  当前批次设置“允许学生选择考试日期”无法取消勾选，若想取消请在本批次中去掉“允许学生选择考试日期”勾选
                </div> -->
              </el-form-item>

              <el-form-item v-model="importForm.Filedata" label="3.导入文件">
                <ots-upload-file :httpRequest="handleFormData" fileType="xlsx" />
              </el-form-item>
              
            </el-form>
            <div class="impExplain">
              <span class="tipTitle"><i></i>提示：</span>
              <div>
                <div>1：模板中<span class="col_red">*</span>字段为必填项</div>
                <div>2：只能上传扩展名为<span class="col_red">.xlsx</span>的文件；
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="baseImportDialog = false">取消</el-button>
          <el-button round type="primary" @click="rightImport">导入</el-button>
        </template>
      </ots-custom-dialog>

      <ots-custom-dialog :dialog.sync="upLoadImgDialog" title="照片上传">
        <template v-slot:content>
          <div class="exportDialog">
            <el-form>
              <el-form-item label="选择批次" class="mb20">
                <el-select v-model="upLoadImgForm.planId" clearable placeholder="请选择">
                  <el-option v-for="item in examBatchList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <p style="margin-bottom: 8px;">请选择照片信息文件</p>
              <el-form-item v-show="false" style="margin-top: 24px;">
                <el-radio v-model="upLoadImgForm.fileType" label="1">基础照片</el-radio>
                <el-radio v-model="upLoadImgForm.fileType" label="2">报名照片</el-radio>
              </el-form-item>
              <el-form-item v-model="upLoadImgForm.Filedata">
                <ots-upload-file ref="importImg" :httpRequest="handleImgFormData" fileType="zip" />
              </el-form-item>
            </el-form>
            <div class="impExplain">
              <span class="tipTitle"><i></i>提示：</span>
              <div>
                <div>1：只能上传扩展名为<span class="col_red">.zip</span>的文件；</div>
                <div>2：文件大小不能超过<span class="col_red">10M</span>；</div>
                <div>3：文件名不能是中文,<span class="col_red">照片以证件号命名；</span></div>
                <div>4：压缩包内只能是照片（不包含文件夹）；</div>
                <div>5：多批次导入照片以最后一次导入为准；</div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="upLoadImgDialog = false">取消</el-button>
          <el-button round type="primary" @click="submitUploadImg">导入</el-button>
        </template>
      </ots-custom-dialog>

      <ots-custom-dialog
        :dialog.sync="repeatPsdDialog"
        title="重置密码"
        width="480px"
      >
        <template v-slot:content>
          <div class="repass">
            <div class="name">
              <span class="name-realname">姓名：</span>
              <span>{{ rePassRealName }}</span>
            </div>
            <el-form :model="resetPass" ref="resetPass" :rules="passRule">
              <el-form-item label="新密码" prop="password">
                <el-input
                  v-model="resetPass.password"
                  placeholder="请输入新密码"
                  type="password"
                ></el-input>
                <ots-password-tooltip></ots-password-tooltip>
              </el-form-item>
              <el-form-item label="确认新密码" prop="confirmPassword">
                <el-input
                  v-model="resetPass.confirmPassword"
                  placeholder="请输入新密码"
                  type="password"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="repeatPsdDialog = false">取消</el-button>
          <el-button round type="primary" @click="submitRepeatPsd('resetPass')">确定</el-button>
        </template>
      </ots-custom-dialog>

      <ots-refer :selectList="teaSelectList" :requestForm="requestForm" @search="search"></ots-refer>

      <div class="mainCon">




        <ots-table-new :descript="descript" :tableHeader="tableHeader" :tableData="tableData" :batchOperBtn="batchOperBtn" @changeCity="changeCityFN" :key="Timer"></ots-table-new>
        <ots-pagination @changeNum="changeNum" @changePage="changePage" :pagination="pagination"></ots-pagination>
      </div>

      <ots-custom-dialog
        :dialog.sync="PhotoUseUpDialog"
        title="照片次数用尽考生"
        width="90%"
      >
        <template v-slot:content>
          <div class="mainCon">
            <ots-table-group-new
              ref="ots-table-Photo"
              :selectList="PhotoSelectList"
              :requestForm="PhotoUseUpForm"
              @search="searchPhotoList"
              :tableHeader="photoTableHeader"
              :tableData="photoTableData"
              :pagination="PhotoPagination"
              @changeNum="PhotoChangeNum"
              @changePage="PhotoChangePage"
              :showAdvancedNumber="4"
            ></ots-table-group-new>
            <!-- <ots-table-new :tableHeader="photoTableHeader" :tableData="photoTableData" :key="Timer"></ots-table-new> -->
            <!-- <ots-pagination @changeNum="PhotoChangeNum" @changePage="PhotoChangePage" :pagination="PhotoPagination"></ots-pagination> -->
          </div>
        </template>
      </ots-custom-dialog>

      <!-- exemptFileDialog -->
      <ots-custom-dialog
        :dialog.sync="exemptFileDialog"
        title="查看免考材料"
        width="60%"
      >
        <template v-slot:content>
          <div style="width: 70%; margin: 16px auto;">
            <p style="margin-bottom: 8px;">免考课程：{{exemptData.courseName}}</p>
            <p style="margin-bottom: 8px;">免考原因：{{exemptData.reasonName}}</p>
            <ul class="showFile">
            <li v-for="item in exemptData.fileList" :key="item.id" @click="openApplyFile(item.url)">
              <img :src="item.fileext == 'pdf'? defaultUrl: item.url" alt="">
              <p>{{ item.filename }}</p>
            </li>
          </ul>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="exemptFileDialog = false">取消</el-button>
          <el-button round type="primary" @click="exemptFileDialog = false">确定</el-button>
        </template>
      </ots-custom-dialog>



    </template>
    <template v-else>
      <router-view></router-view>
    </template>
  </div>
</template>

<script>
import { passWordStrength } from "@/common/verify.js";
import moment from "moment";
import {
  getSinglePlan,
  getSelectPlanFn,
  getCurrentPlanFn,
  getPagePlan,
  getPlanSignDateCountShow,
  photoVerifyLogAPI,
  photoVerifyLogDeleteAPI
} from "@/http/modules/examSet/examBatch";
import {
  selectList,
  planStudentImport,
  studentExport,
  excelTempCreate,
  getPlanCourseList,
} from "@/http/modules/custom";

import { getStudentCourseExemptListAPI, exportStudentCourseExemptFileAPI, getPlanCourseExemptScopeAPI } from '@/http/modules/baseSet/course'

import { judgeIsPay } from "@/http/modules/home.js";

export default {
  data() {
    return {
      defaultUrl: require("@/assets/img/PDFIcon.png"),
      PhotoUseUpDialog: false, // 筛选照片次数用尽考生弹窗
      PhotoUseUpForm: {
        page: 1,
        size: 10,
        planId: "",
        stateType: "",
        photoState: "",
        searchKey: "",
      },
      PhotoSelectList: [
        {
          title: "考试批次",
          type: "select",
          isSearch: true,
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "人身核验状态",
          type: "select",
          isSearch: true,
          requestKey: "photoState",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
            { id: 0, name: "系统不通过" },
            { id: 1, name: "系统通过" },
            { id: 2, name: "人工通过" },
            { id: 4, name: "无基础照片" },
            { id: 3, name: "无报名照片"}
          ],
        },
        {
          title: "审核状态",
          type: "select",
          requestKey: "stateType",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "关键词",
          type: "input",
          requestKey: "searchKey",
          placeholder: "姓名/证件号",
        },
      ],

      apptitle: false,
      endTime: "",
      appointment: [],
      mainTopBtnList: [
        {
          title: "批量导入",
          select: true,
          plain: true,
          children: [
            { title: "基本信息导入", fn: this.baseImport },
            { title: "学生照片导入", fn: this.phoneImport },
          ],
        },
        {
          title: "免考材料导出",
          plain: true,
          fn: this.exportExempt,
        },
        {
          title: "导出",
          plain: true,
          fn: this.exportStu,
        },
        {
          title: "新增",
          fn: this.addUser,
        },
      ],
      baseImportDialog: false,
      passRule: {
        password: [
          { required: true, message: "请输入设置密码", trigger: "blur" },
          { validator: passWordStrength, trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          { validator: this.confirmPassword, trigger: "blur" },
        ],
      },
      forbidden: 1,
      importForm: {
        limitRegionState: 1,
        preRegistrationState: 1,
        gradationForbidden: 1,
        subjectForbidden: 1,
        courseForbidden: 1,
        planId: "",
        file: "",
      },
      upLoadImgDialog: false,
      repeatPsdDialog: false,
      editPsdQuery: {
        realName: "",
        userId: "",
        password: "",
        confirmPassword: "",
      },
      upLoadImgForm: {
        Filedata: "",
        planId: "",
        fileType: "1",
      },
      requestForm: {
        page: 1,
        size: 10,
        planId: "",
        schoolId: "",
        stationId: [""],
        orders: "",
        stateType: "",
        photoState: "",
        payType: "",
        mobileApplyState: "",
        searchKey: "",
        phone: "",
        courseId: "",
        applyState: "",
        exemptExam: "",
        photoCheckCode: "",
      },
      teaSelectList: [
        {
          title: "考试批次",
          type: "select",
          isSearch: true,
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "院校",
          type: "select",
          isSearch: true,
          requestKey: "schoolId",
          label: "name",
          value: "id",
          data: [{ id: "", name: "全部" }],
        },
        {
          // title: this.isSetStateName,
          title: "教学点",
          type: "select",
          isSearch: true,
          requestKey: "stationId",
          label: "name",
          value: "id",
          data: [{ id: "", name: "全部" }],
        },

        {
          title: "人身核验状态",
          type: "select",
          isSearch: true,
          requestKey: "photoState",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
            { id: 0, name: "系统不通过" },
            { id: 1, name: "系统通过" },
            { id: 2, name: "人工通过" },
            { id: 4, name: "无基础照片" },
            { id: 3, name: "无报名照片"}
          ],
        },
        {
          title: "审核状态",
          type: "select",
          requestKey: "stateType",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "缴费状态",
          type: "select",
          isSearch: true,
          requestKey: "payType",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
            { id: 1, name: "已缴费" },
            { id: 0, name: "未缴费" },
            { id: 2, name: "退费" }
          ],
        },
        {
          title: "关键词",
          type: "input",
          requestKey: "searchKey",
          placeholder: "姓名/证件号",
        },
        {
          title: "报考课程",
          type: "select",
          requestKey: "courseId",
          label: "courseName",
          value: "courseId",
          data: [],
        },
        {
          title: "手机号",
          type: "input",
          requestKey: "phone",
          placeholder: "请输入",
        },
        {
          title: "报名终端",
          type: "select",
          requestKey: "mobileApplyState",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
            { id: 1, name: "移动端报名" },
            { id: 0, name: "PC端报名" },
          ],
        },
        {
          title: "报名状态",
          type: "select",
          requestKey: "applyState",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
            { id: 1, name: "已报名" },
            { id: 0, name: "未报名" },
          ]
        },
        {
          title: "是否申请免考",
          type: "select",
          requestKey: "exemptExam",
          label: "name",
          value: "id",
          notShow: true,
          data: [
            { id: "", name: "全部" },
            { id: 1, name: "是" },
            { id: 0, name: "否" },
          ]
        },
        {
          title: "照片合规检测",
          type: "select",
          requestKey: "photoCheckCode",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
            { id: 1, name: "合规" },
            { id: 0, name: "不合规" },
            { id: -1, name: "未检测" },
          ]
        },
      ],
      tableHeader: [
        {
          title: "批次状态",
          width: "120",
          prop: "planState",
          fixed: "left",
        },
        {
          title: "姓名",
          width: "80",
          prop: "realName",
          fixed: "left",
        },
        {
          title: "证件号",
          width: "200",
          prop: "cardNo",
          fixed: "left",
        },
        {
          title: "报考课程",
          prop: "course",
          width: "100",
          fixed: "left",
        },
        {
          title: "性别",
          width: "60",
          prop: "sex",
        },

        {
          title: "手机号",
          width: "115",
          prop: "phone",
        },
        {
          title: "院校",
          width: "200",
          prop: "school",
        },
        {
          title: "教学点",
          prop: "station",
          width: "200",
        },
        {
          title: "基础照片",
          type: "img",
          prop: "photo",
          fixed: "right",
          width: "120"
        },
        {
          title: "报名照片",
          type: "img",
          prop: "photoUrl",
          fixed: "right",
          width: "120"
        },
        {
          title: "照片合规检测状态",
          prop: "photoCheckMsg",
          type: "tag_Q",
          tagColor: (scope) => {
            if (scope.row.photoCheckMsg == "照片检测正常" || scope.row.photoCheckMsg == "未检测") {
              return "";
            } else {
              return "col_red";
            }
          },
          // fixed: "right",
          width: "142"
        },
        {
          title: "人身核验状态",
          prop: "photoState",
          type: "state",
          stateFlag: (scope) => {
            const options = {
              人工通过: "green",
              系统通过: "green",
              系统不通过: "red",
              无报名照片: "red",
              无基础照片: "red"
            };
            return options[scope.row.photoState];
          },
          width: "120",
          // fixed: "right",
        },
        {
          title: "审核状态",
          prop: "stateType",
          type: "state",
          stateFlag: (scope) => {
            const options = {
              待初审: "orange",
              初审不通过: "red",
              待终审: "orange",
              终审通过: "green",
              终审不通过: "red",
            };
            return options[scope.row.stateType];
          },
          // fixed: "right",
          width: "110",
        },
        {
          title: "缴费状态",
          prop: "payType",
          type: "tag_Q",
          tagColor: (scope) => {
            const options = {
              已缴费: "",
              未缴费: "col_grayQ",
            };
            return options[scope.row.payType];
          },
          width: "85",
          // fixed: "right",
        },
        {
          title: "报名终端",
          prop: "mobileApplyState",
          width: "120",
          // fixed: "right",
        },
        {
          title: "免考材料",
          type: "button",
          prop: "exempt",
          formatter: (val) => "查看",
          fixed: "right",
          width: "120px",
          notShow: true,
          disableFn: (scope) => {
            if (scope.row.exemptExam == 1) {
              return false;
            } else {
              return true;
            }
          },
          click: this.showExemptFile,
        },
        {
          title: "操作",
          type: "buttons_set",
          width: "165",
          fixed: "right",
          align: "right",
          headerAlign: "right",
          disabled: true,
          tableSettings: {
            content: "单课程显示",
            icon: 'el-icon-sort',
            click: this.changeSet,
          },
          btnList: [
            {
              title: "重置密码",
              click: this.repeatPsd,
              formatter: () => {
                return !this.Flag
              }
            },
            {
              title: "编辑",
              formatter: (scope) => {
                if (scope.row.stateType == "终审通过") {
                  return true
                } else if (!this.Flag) {
                  return true
                } else {
                  return false
                }
              },
              click: this.edit,
            },
            {
              title: "删除",
              formatter: (scope) => {
                return scope.row.payType === "已缴费" || this.Flag == false;
              },
              click: this.delet,
            },
          ],
        },
      ],
      tableData: [],
      batchOperBtn: [],
      pagination: {
        total: 0,
      },
      needAudit: "",
      roleType: "",
      customSearch: [],
      isSetStateName: "",
      optionalSession: "",
      examBatchList: [],
      planInfo: {},
      optionalExam: "",
      stateDisabled: false,
      Flag: true,
      Timer: '',
      courseList: [],
      descript: "",
      photoContrastType: 1,
      resetPass: {
        password: "",
        confirmPassword: "",
        userId: "",
        tenant: "",
      },
      rePassUserName: '',
      rePassRealName: '',
      isShowLevel: false,
      isShowSubject: false,
      // 筛选照片次数用尽考生
      photoTableData: [],
      photoTableHeader: [
        {
          title: "姓名",
          prop: "realName",
          width: "80px"
        },
        {
          title: "性别",
          prop: "sexName",
          width: "80px",
        },
        {
          title: "证件号",
          prop: "cardNo",
        },
        {
          title: "审核状态",
          prop: "auditState",
          type: "state",
          stateFlag: (scope) => {
            const options = {
              待初审: "orange",
              初审不通过: "red",
              待终审: "orange",
              终审通过: "green",
              终审不通过: "red",
            };
            return options[scope.row.auditState];
          },
        },
        {
          title: "报名照片",
          type: "imageArray",
          prop: "photo",
          width: "136px;"
        },
        {
          title: "人身核验状态",
          prop: "photoState",
          type: "state",
          stateFlag: (scope) => {
            const options = {
              人工通过: "green",
              系统通过: "green",
              系统不通过: "red",
              无报名照片: "red",
              无基础照片: "red"
            };
            return options[scope.row.photoState];
          },
        },
        {
          title: "上传照片时间",
          prop: "createDate",
          width: "175px",
          type: "textArray"
        },
        {
          title: "人身核验描述",
          prop: "returnMsg",
          width: "400px",
          type: "textArray"
        },
        {
          title: "操作",
          type: "buttons",
          btnList: [
            {
              title: "删除照片记录",
              formatter: (scope) => {
                if (scope.row.canDelete == 0) {
                  return true
                } else {
                  return false
                }
              },
              click: this.deleteRecord,
            },
          ],
        },
      ],
      PhotoPagination: {
        total: 0,
      },
      exemptFileDialog: false,
      exemptData: {},
      isNotShowFlag: true,
    };
  },
  computed: {
    isApplyManage() {
      return this.$route.name === "applyManage";
    },

    getMainTopBtnList() {
      let mainTopBtnList = [];
      // let item = {
      //   title: "筛选照片次数用尽考生",
      //   plain: true,
      //   fn: this.PhotoUseUp,
      // }
      if (this.planInfo.planState === "2" || this.planInfo.planState === "3") {
        mainTopBtnList = [
          {
            title: "筛选照片次数用尽考生",
            plain: true,
            fn: this.PhotoUseUp,
          },
          {
            title: "批量导入",
            select: true,
            plain: true,
            children: [
              { title: "基本信息导入", fn: this.baseImport },
              { title: "学生照片导入", fn: this.phoneImport },
            ],
          },
          {
            title: "免考材料导出",
            plain: true,
            notShow: this.isNotShowFlag,
            fn: this.exportExempt,
          },
          {
            title: "导出",
            plain: true,
            fn: this.exportStu,
          },
          {
            title: "新增",
            fn: this.addUser,
          },
        ];
      } else {
        mainTopBtnList = [
          {
            title: "免考材料导出",
            plain: true,
            fn: this.exportExempt,
            notShow: this.isNotShowFlag,
          },
          {
            title: "导出",
            plain: true,
            fn: this.exportStu,
          },
        ];
      }

      // mainTopBtnList = [item, ...mainTopBtnList];

      return mainTopBtnList;
    },
  },

  watch: {
    "Flag": function name(val) {
      this.descript = val ? '' : '若想操作功能，请切换到多课程显示模式';
    },
    
    "upLoadImgForm.planId": function(planId) {
      getCurrentPlanFn({ planId }).then(({data, code}) => {
        if (code === 1) {
          this.photoContrastType = data.photoContrastType;
          this.upLoadImgForm.fileType = data.photoContrastType == '1' ? '2' : '1';
        }
      })
    },

    "requestForm.planId": function (val) {
      this.Flag = true
      this.tableHeader.map(e => {
        if (e.type == 'buttons_set') {
          e.tableSettings.content = this.Flag ? '单课程显示': '多课程显示'
        }
      })
      this.Timer = new Date().getTime()
      this.planSearch();
      this.getPlanSignDateCount();
      this.getCurrentPlan();
      this.getPlanCourse(val);
      this.isShowExempt(val);
      if (val) {
        let plan = this.teaSelectList[0].data.filter((item) => item.id == val);
        if (plan.length) {
          this.planInfo = plan[0];
        } else {
          this.planInfo = {};
        }
      }
    },

    "importForm.planId": function () {
      this.getSinglePlanFn();
    },

    "PhotoUseUpForm.planId": function() {
      this.PhotoUseUpForm.stateType = "";
      this.PhotoUseUpForm.photoState = "";
      this.PhotoUseUpForm.searchKey = "";
      this.searchPhotoList();
    },   
    // "PhotoUseUpForm.planId": function() {
    //   this.PhotoUseUpForm.stateType = "";
    //   this.PhotoUseUpForm.photoState = "";
    //   this.PhotoUseUpForm.searchKey = "";
    //   this.searchPhotoList();
    // },

    $route() {
      if (this.$route.name == "applyManage") {
        this.getTableList();
      }
    },
  },

  mounted() {
    // this.isSetState();
    this.getExamBatch();
  },

  created() {
    this.getData();
    this.getPlanSignDateCount();
  },

  methods: {
    // 是否显示免考相关
    async isShowExempt(planId) {
      const { data } = await getPlanCourseExemptScopeAPI({planId});
      let flag = data.length > 0;
      this.isNotShowFlag = !flag;
    
      this.tableHeader.map(e => {
        if (e.prop == "exempt") {
          e.notShow = !flag;
        }
      })

      this.teaSelectList.map(e => {
        if (e.requestKey == "exemptExam") {
          e.notShow = !flag;
          return;
        }
      })
    },

    // 查看免考材料
    async showExemptFile(row) {
      let params = {
        planId: this.requestForm.planId,
        studentUserId: row.id
      }
      const { data } = await getStudentCourseExemptListAPI(params);
      this.exemptData = data[0];
      this.exemptFileDialog = true;
    },
    // 打开材料
    openApplyFile(val) {
      window.open(val);
    },

    async exportExempt() {
      let params = { ...this.requestForm };
      delete params.page;
      delete params.size;
      const { code, data } =  await exportStudentCourseExemptFileAPI(params);
      if (code && data) {
        window.open(data);
      }
    },

    // 照片次数用尽
    PhotoUseUp() {
      let { planId, stateType, photoState, searchKey} = this.requestForm;
      this.PhotoUseUpForm.planId = planId;
      this.PhotoUseUpForm.stateType = stateType;
      this.PhotoUseUpForm.photoState = photoState;
      this.PhotoUseUpForm.searchKey = searchKey;
      this.searchPhotoList();
      this.PhotoUseUpDialog = true;
    },
    // 照片次数用尽 ==> 搜索
    searchPhotoList() {
      this.PhotoUseUpForm.page = 1;
      this.getPhotoUseUpInfo();
    },
    // 照片次数用尽 ==> 获取表格数据
    async getPhotoUseUpInfo() {
      // 审核状态下拉
      let auditList_1 = [
        { id: "", name: "全部" },
        { id: "3", name: "待终审" },
        { id: "4", name: "终审通过" },
        { id: "5", name: "终审不通过" },
      ];
      let auditList_2 = [
        { id: "", name: "全部" },
        { id: "1", name: "待初审" },
        { id: "2", name: "初审不通过" },
        { id: "3", name: "待终审" },
        { id: "4", name: "终审通过" },
        { id: "5", name: "终审不通过" },
      ];
      let auditList_3 = [
        { id: "", name: "全部" }, 
        { id: "4", name: "审核通过" },
        { id: "6", name: "审核不通过" },
      ];
      const { data } = await getSinglePlan({planId: this.PhotoUseUpForm.planId});
      let { needAudit } = data;
      if (needAudit == 1) {
        this.$set(this.PhotoSelectList[2], "data", auditList_1);
      } else if (needAudit == 2) {
        this.$set(this.PhotoSelectList[2], "data", auditList_2);
      } else {
        this.$set(this.PhotoSelectList[2], "data", auditList_3);
      }

      let params = { ...this.PhotoUseUpForm };
      const res = await photoVerifyLogAPI(params);
      this.photoTableData = res.data.records;
      this.PhotoPagination.total = res.data.total;
    },
    // 删除上传记录
    async deleteRecord(row) {
      let params = {
        planId: row.planId,
        userId: row.userId
      }
      const { code } = await photoVerifyLogDeleteAPI(params);
      if (code) {
        this.getPhotoUseUpInfo();
        this.$message.success("删除照片记录成功！");
      }
    },
    // 照片次数用尽，数量
    PhotoChangeNum(num) {
      this.PhotoUseUpForm.size = num;
      this.getPhotoUseUpInfo();
    },
    // 照片次数用尽，页码
    PhotoChangePage(p) {
      this.PhotoUseUpForm.page = p;
      this.getPhotoUseUpInfo();
    },
    











    confirmPassword(rule, value, callback) {
      if (value) {
        if (this.resetPass.password !== this.resetPass.confirmPassword) {
          callback(new Error("设置密码和确认密码必须相同"));
        } else {
          callback();
        }
      }
      callback();
    },

    changeSet() {
      this.Flag = !this.Flag
      this.tableHeader.map(e => {
        if (e.type == 'buttons_set') {
          e.tableSettings.content = this.Flag ? '单课程显示': '多课程显示'
        }
      })
      this.getTableList()
      this.Timer = new Date().getTime()
    },

    getExamBatch() {
      getSelectPlanFn({ needAudit: 5 }).then((res) => {
        if (res.code === 1) {
          this.examBatchList = res.data;
          if (res.data.length === 1) {
            this.importForm.planId = res.data[0].id;
            this.upLoadImgForm.planId = res.data[0].id;
          }
        }
      });
    },
    
    isSetState() {
      this.teaSelectList[2].title = "教学点";
      this.tableHeader[6].title = "教学点";
    },

    getData() {
      const typeList = [
        "select",
        "province",
        "subject",
        "nation",
        "politicalStatus",
        "level",
      ];
      this.mixin_setUserExtInfo().then((res) => {
        res.data.map((item) => {
          if (item.type == 'level') {
            this.isShowLevel = true;
          }

          if (item.type == 'subject') {
            this.isShowSubject = true;
          }

          if (item.queryCondition == 1) {
            if (typeList.includes(item.type)) {
              if (item.valueVo) {
                let search = {
                  title: item.displayName,
                  type: "select",
                  requestKey: item.name,
                  label: "name",
                  value: "name",
                  data: [{ name: "全部" }, ...item.valueVo],
                };
                this.customSearch.push(search);
              }
            } else if (item.type == "text") {
              let search = {
                title: item.displayName,
                type: "input",
                requestKey: item.name,
                placeholder: "请输入",
              };
              this.customSearch.push(search);
            } else if (item.type == "provinceCity") {
              let search = {
                title: item.displayName,
                type: "cascader",
                requestKey: item.name,
                label: "name",
                value: "name",
                data: [{ name: "全部" }, ...item.valueVo],
              };
              this.customSearch.push(search);
            }
          }
          if (item.type == "imageUpload") {
            let tables = {
              title: item.displayName,
              type: "img",
              width: "120",
              prop: item.name,
            };
            this.tableHeader.push(tables);
          } else {
            let tables = {
              title: item.displayName,
              width: "120",
              prop: item.name,
            };
            this.tableHeader.push(tables);
          }
        });
        this.requestForm = Object.assign(this.requestForm, res.requestForm);
        this.teaSelectList = [...this.teaSelectList, ...this.customSearch];
      });

      getPagePlan({ publish: 1 }).then((data) => {
        this.$set(this.teaSelectList[0], "data", data.data);
        this.$set(this.PhotoSelectList[0], "data", data.data);

        this.requestForm.planId = data.data[0].id;
        this.getCurrentPlan();
      });

      this.mixin_getSelectSchool().then((data) => {
        let newSchoolList = [{ id: "", name: "全部" }, ...data];
        this.$set(this.teaSelectList[1], "data", newSchoolList);
      });

      this.mixin_getSelectStation().then((data) => {
        let newStationList = [{ id: "", name: "全部" }, ...data];
        this.$set(this.teaSelectList[2], "data", newStationList);
      });

      judgeIsPay().then(({ data }) => {
        if (data != 1) {
          this.tableHeader.map((e, i) => {
            if (e.prop == "payType") {
              this.tableHeader.splice(i, 1);
            }
          });
          this.teaSelectList.map((item, index) => {
            if (item.requestKey == "payType") {
              this.teaSelectList.splice(index, 1);
            }
          });
        }
      });
    },

    getPlanCourse(val) {
      this.requestForm.courseId = "";
      getPlanCourseList({ planId: val }).then((data) => {
        let newSchoolList = [
          { courseId: "", courseName: "全部" },
          ...data.data,
        ];
        this.teaSelectList.map(e => {
          if (e.requestKey === "courseId") {
            e.data = newSchoolList;
            return;
          }
        })
      });
    },

    async getCurrentPlan() {
      const { data } = await getCurrentPlanFn({ planId: this.requestForm.planId });
      this.endTime = moment(data.endSign).format("YYYY年MM月DD日 HH时mm分ss秒");
      
      let { photoContrastType } = data;

      if (photoContrastType === 2) {
        this.teaSelectList.map( e=> {
          if (e.requestKey === "photoState" && e.data[4].id != 4) {
            let item = { id: 4, name: "无基础照片" };
            e.data.splice(4, 0, item);
            return;
          }
        })
        if (this.tableHeader[8].prop !== "photo") {
          let item = {
            prop: "photo",
            title: "基础照片",
            type: "img",
            fixed: "right",
            width: 120,
          };
          this.tableHeader.splice(8, 0, item);
        }
      } else {
        this.teaSelectList.map( e=> {
          if (e.requestKey === "photoState" && e.data[4].id == 4) {
            e.data.splice(4, 1);
            return;
          }
        })

        if (this.tableHeader[8].prop === "photo") {
          this.tableHeader.splice(8, 1);
        }
      }
    },

    getPlanSignDateCount() {
      getPlanSignDateCountShow({ planId: this.requestForm.planId }).then((res) => {
          this.appointment = res.data;
          if (this.appointment !== null && this.appointment.length) {
            this.apptitle = false;
          } else {
            this.apptitle = true;
          }
        }
      );
    },

    excelTempCreateExt() {
      excelTempCreate().then((res) => {
        window.location.href = res.data;
      });
    },

    baseImport() {
      this.importForm.limitRegionState = 1;
      this.importForm.preRegistrationState = 1;
      this.baseImportDialog = true;
    },

    handleFormData(val) {
      this.importForm.file = val.file;
    },

    rightImport() {
      if (!this.importForm.planId) {
        this.$message.error("请选择导入批次");
        return;
      }
      if (this.optionalSession) {
        if (this.importForm.preRegistrationState != 1) {
          this.$message.warning("批次设置了学生选考点考场，请勾选 “需要学生二次填报” 或 “让学生自己报名” ！");
          return;
        }
      }
      if (!this.importForm.file) {
        this.$message.error("请选择文件");
        return;
      }
      this.importForm.gradationForbidden = this.forbidden;
      this.importForm.subjectForbidden = this.forbidden;
      this.importForm.courseForbidden = this.forbidden;
      const fd = new FormData();
      for (let item in this.importForm) {
        fd.append(item, this.importForm[item]);
      }
      planStudentImport(fd).then((res) => {
        if (res.code) {
          this.baseImportDialog = false;
          const failNum = res.data.errorCount ? parseInt(res.data.errorCount) : 0;
          const totalNum = parseInt(res.data.allCount);
          const successNum = totalNum - failNum;
          let message = `导入完成，成功导入${successNum}，失败人员数${failNum}`;
          this.$confirm(message, "导入结果", {
            confirmButtonText: failNum > 0 ? "查看错误记录" : "确定",
            cancelButtonText: "取消",
            type: failNum > 0 ? "warning" : "success",
          }).then(() => {
            if (failNum > 0) {
              window.location.href = res.data.address;
            }
          });
          this.getTableList();
        }
      });
    },

    phoneImport() {
      this.upLoadImgDialog = true;
    },

    handleImgFormData(val) {
      this.upLoadImgForm.Filedata = val.file;
    },

    submitUploadImg() {
      if (!this.upLoadImgForm.planId) {
        this.$message.error("请选择导入批次");
        return;
      }
      if (!this.upLoadImgForm.Filedata) {
        this.$message.error("请选择文件");
        return;
      }
      const fd = new FormData();
      let param = {
        file: this.upLoadImgForm.Filedata,
        planId: this.upLoadImgForm.planId,
        fileType: this.upLoadImgForm.fileType
      };
      for (let item in param) {
        fd.append(item, param[item]);
      }
      this.$api.applyManage.batchImportUserPhoto(fd).then((res) => {
        if (res.code) {
          const failNum = res.data.errorCount
            ? parseInt(res.data.errorCount)
            : 0;
          const totalNum = parseInt(res.data.allCount);
          const successNum = totalNum - failNum;
          let message = `导入完成，成功导入照片${successNum}张，导入失败${failNum}张`;
          this.upLoadImgDialog = false;
          this.$confirm(message, "导入结果", {
            confirmButtonText: failNum > 0 ? "查看错误记录" : "确定",
            cancelButtonText: "取消",
            type: failNum > 0 ? "warning" : "success",
          }).then(() => {
            if (failNum > 0) {
              window.location.href = res.data.address;
            }
          });
          this.getTableList();
        }
      });
    },

    addUser() {
      this.$router.push({
        path: "applyManage/applyManageAdd",
      });
    },

    async getSinglePlanFn() {
      const { data } = await getSinglePlan({ planId: this.importForm.planId });
      this.optionalExam = data.optionalExamDate;
      this.stateDisabled = this.optionalExam == 1 ? true : false;
    },

    getTableList() {
      for (let key in this.requestForm) {
        if (this.requestForm[key] == "全部") {
          this.requestForm[key] = "";
        }
      }
      getSinglePlan({ planId: this.requestForm.planId }).then((res) => {
        this.courseList = res.data.courseList
        this.tableHeader.map(e => {
          if (e.type == 'buttons_set') {
            e.disabled = this.courseList.length == 1 ? false : true
          }
        })
        this.Timer = new Date().getTime()

        this.optionalSession = res.data.optionalSession == 1;
        if (res.data.needAudit == 1) {
          let dataList = [
            { id: "", name: "全部" },
            { id: "3", name: "待终审" },
            { id: "4", name: "终审通过" },
            { id: "5", name: "终审不通过" },
          ];
          this.$set(this.teaSelectList[4], "data", dataList);
        } else if (res.data.needAudit == 2) {
          let dataList = [
            { id: "", name: "全部" },
            { id: "1", name: "待初审" },
            { id: "2", name: "初审不通过" },
            { id: "3", name: "待终审" },
            { id: "4", name: "终审通过" },
            { id: "5", name: "终审不通过" },
          ];
          this.$set(this.teaSelectList[4], "data", dataList);
        } else {
          let dataList = [
            { id: "", name: "全部" }, 
            { id: "4", name: "审核通过" },
            { id: "6", name: "审核不通过" },
          ];
          this.$set(this.teaSelectList[4], "data", dataList);
        }
      });
      let params = { ...this.requestForm };
      if (typeof params.stationId == "object") {
        params.stationId = params.stationId.join(",");
      }

      params.rowCourseFlag = this.Flag ? 'complex': 'singular';
      selectList(params).then((res) => {
        if (res.code) {
          this.tableData = res.data.records;
          this.pagination.total = res.data.total;
          res.data.records.forEach((e) => {
            e.extData.forEach((item) => {
              e[item.name] = item.value;
            });
          });
        }
      });
    },

    // 重置密码
    // 2024年7月23日 ==> 需求修改为取消手动输入，设置为默认后六位。（后端修改）
    async repeatPsd(val) {
      let { realName } = val;
      let msg = `重置 ${realName} 的密码？（新密码为证件号后 6 位）`;
      this.$confirm(msg, "重置密码", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let params = {
          userId: val.stuid,
          tenant: window.localStorage.getItem("tenant"),
          setDefault: 1,
          password: '',
          confirmPassword: '',
        }
        const { code } = await this.$api.login.editPsd(params);
        if (code == 1) {
          this.$message.success("重置密码，操作成功！");
        }
      });
    },

    // 重置密码（弹窗）
    submitRepeatPsd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$api.login.editPsd(this.resetPass).then((res) => {
            if (res.code == 1) {
              this.$message.success("操作成功！");
              this.repeatPsdDialog = false;
            }
          });
        } else {
          console.log("Error Submit");
          return false;
        }
      });
    },

    edit(val) {
      this.$router.push({
        path: "/applyManage/applyManageAdd",
        query: val,
      });
    },

    delet(val) {
      let stuid = val.stuid;
      let planId = val.planId;
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api.applyManage.del({ stuid, planId }).then((res) => {
          if (res.code) {
            this.$message.success("删除成功！");
            this.getTableList();
          }
        });
      });
    },

    exportStu() {
      let { page, size, ...queryFrom } = this.requestForm;
      if (typeof queryFrom.stationId == "object") {
        queryFrom.stationId = queryFrom.stationId.join(",");
      }
      queryFrom.rowCourseFlag = this.Flag ? 'complex': 'singular';
      studentExport(queryFrom).then((res) => {
        if (res.code) {
          window.open(res.data);
        }
      });
    },

    search() {
      this.requestForm.page = 1;
      this.getTableList();
    },

    planSearch() {
      this.requestForm.page = 1;
      this.requestForm.stateType = "";
      this.getTableList();
    },

    changeNum(num) {
      this.requestForm.size = num;
      this.getTableList();
    },

    changePage(p) {
      this.requestForm.page = p;
      this.getTableList();
    },

    changeCityFN(e, attr) {
      this.requestForm[attr] = e.toString();
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .markField {
  line-height: 24px;
  &>span {
    color: #FE5958;
  }
}

.repass {
  .name {
    width: 50%;
    display: inline-block;
    padding-left: 4px;
    box-sizing: border-box;
    margin-bottom: 32px;

    .name-username,
    .name-realname {
      color: #737780;
      font-size: 14px;
      font-weight: 400;
      display: inline-block;
      margin-right: 16px;
    }

    .name-username + span,
    .name-realname + span {
      color: #45494d;
    }
  }

  .el-form {
    width: 100%;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;

    .el-form-item {
      width: 408px;

      /deep/ .el-form-item__label {
        color: #737780;
      }
    }

    /deep/ .el-input__inner {
      width: 408px;
    }

    .checkUser {
      width: 100%;
      background: #f8f9fc;
      border-radius: 4px;
      padding: 19px 0 0 16px;
      margin-bottom: 22px;

      /deep/ .el-checkbox-group {
        display: flex;
        flex-wrap: wrap;

        .el-checkbox {
          margin-right: 0;
          margin-bottom: 12px;
          width: 50%;
        }
      }
    }
  }
}
.applyManage {
  .el-alert {
    margin-bottom: 24px;
    background: #fff5e0;
    border: 1px solid #ff9500;
    box-sizing: border-box;
    .importantNote {
      font-size: 14px;
      color: #ff9500;
      margin-left: -10px;
      margin-top: -7px;
    }
    /deep/ .el-alert__closebtn {
      top: 14px;
      color: #ff9500;
    }
  }
  /deep/ .unDistributed {
    position: relative;
    margin-left: 10px;
    &:after {
      content: " ";
      position: absolute;
      left: -10px;
      top: 7px;
      width: 5px;
      height: 5px;
      background-color: #fe5958;
      border-radius: 50%;
    }
  }
  /deep/ .unFinish {
    position: relative;
    margin-left: 10px;
    &:after {
      content: " ";
      position: absolute;
      left: -10px;
      top: 7px;
      width: 5px;
      height: 5px;
      background-color: #006aff;
      border-radius: 50%;
    }
  }
  /deep/ .wait {
    position: relative;
    margin-left: 10px;
    &:after {
      content: " ";
      position: absolute;
      left: -10px;
      top: 7px;
      width: 5px;
      height: 5px;
      background-color: #f27900;
      border-radius: 50%;
    }
  }
  /deep/ .finish {
    position: relative;
    margin-left: 10px;
    &:after {
      content: " ";
      position: absolute;
      left: -10px;
      top: 7px;
      width: 5px;
      height: 5px;
      background-color: #1dbf60;
      border-radius: 50%;
    }
  }
}
.exportDialog {
  .impExplain {
    margin-top: 32px;
    color: #9299a6;
    // display: flex;
    .tipTitle {
      flex-shrink: 0;
      display: block;
      margin-bottom: 12px;
    }
    div {
      line-height: 1.8;
    }
  }
}
.downTemplate {
  display: block;
  padding: 8px 0 0px 0;
  color: #3388ff;
  font-size: 13px;
  text-decoration: none;
}
.repeatPsd {
  font-size: 14px;
  color: #45494d;
  span {
    color: #2d2f33;
    font-weight: 600;
  }
}
.illustration {
  line-height: 15px;
  margin: 10px 10px 0 10px;
  color: #9299a6;
}
.showFile {
  &>li {
    display: flex; 
    align-items: center; 
    margin-top: 16px; 
    border: 1px dashed #CCC; 
    border-radius: 8px;
    cursor: pointer;
    &>img {
      width: 120px; 
      height: 120px;
    }
    &>p{
      margin-left: 16px;
    }
  }
}
</style>
